"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var url_exports = {};
__export(url_exports, {
  formatUrl: () => formatUrl
});
module.exports = __toCommonJS(url_exports);
var import_guard = require("@cartographerio/guard");
function formatQueryValue(value) {
  if (typeof value === "string") {
    return value;
  } else if (typeof value === "number") {
    return value.toString(10);
  } else {
    return value ? "true" : "false";
  }
}
function formatUrl(baseUrl, parts) {
  const { path, query, fragment, encodePath = true } = parts;
  let ans = baseUrl;
  let sep = "?";
  if (path != null) {
    ans += encodePath ? encodeURI(path) : path;
  }
  function kvp(key, value) {
    ans += sep;
    ans += encodeURIComponent(key);
    ans += "=";
    ans += encodeURIComponent(formatQueryValue(value));
    sep = "&";
  }
  if (typeof query === "object") {
    for (const key in query) {
      const value = query[key];
      if ((0, import_guard.isArray)(value)) {
        for (const item of value) {
          kvp(key, item);
        }
      } else if (value != null) {
        kvp(key, value);
      }
    }
  }
  if (fragment != null) {
    ans += "#" + encodeURIComponent(fragment);
  }
  return ans;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  formatUrl
});
//# sourceMappingURL=url.js.map
